<template>
  <div>
    <div class="wrapper my-8 mx-8 d-flex flex-column">
      <p>
        <span
          style="color: rgb(0, 170, 221); cursor: pointer"
          @click="$router.push('/')"
          >Dashboard /</span
        >
        Doctors
      </p>
      <h2 class="mt-6">Doctors</h2>
      <div class="cell mt-10">
        <div class="my-3 mx-10" style="display: flex; align-items: center">
          <p>Status:</p>
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <p class="text-capitalize ml-2 black--text" v-on="on">
                {{ statusSearch }}
                <v-icon small left>mdi-chevron-down</v-icon>
              </p>
            </template>
            <v-list>
              <v-list-item
                v-for="(item, index) in [
                  'All',
                  'Pending',
                  'Accepted',
                  'Rejected',
                  'Blocked',
                ]"
                :key="index"
                @click="
                  statusSearch = item;
                  currentPage = 1;
                  searchByStatus(item.toLowerCase());
                "
              >
                <p>{{ item }}</p>
              </v-list-item>
            </v-list>
          </v-menu>

          <p class="ml-4">Prefecture:</p>
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <p class="text-capitalize ml-2 black--text" v-on="on">
                {{ prefecture }}
                <v-icon small left>mdi-chevron-down</v-icon>
              </p>
            </template>
            <v-list max-height="600" style="overflow-y: auto">
              <v-list-item
                v-for="(item, index) in $store.state.prefectures"
                :key="index"
                @click="
                  prefecture = item.option_value;
                  prefectureId = item.option_key;
                  currentPage = 1;
                  searchByStatus();
                "
              >
                <p>{{ item.option_value }}</p>
              </v-list-item>
            </v-list>
          </v-menu>

          <p class="ml-4">Municipality:</p>
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <p class="text-capitalize ml-2 black--text" v-on="on">
                {{ municipality }}
                <v-icon small left>mdi-chevron-down</v-icon>
              </p>
            </template>
            <v-list max-height="600" style="overflow-y: auto">
              <v-list-item
                v-for="(item, index) in $store.state.municipalities"
                :key="index"
                @click="
                  municipality = item.option_value;
                  municipalityId = item.option_key;
                  currentPage = 1;
                  searchByStatus();
                "
              >
                <p>{{ item.option_value }}</p>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-spacer></v-spacer>
          <div class="mr-2 d-flex align-center">
            <v-text-field
              prepend-inner-icon="mdi-magnify"
              v-model="search"
              label="Search.."
              color="rgb(0,170,221)"
            ></v-text-field>
            <v-btn
              :loading="$store.state.loading"
              width="20"
              rounded
              text
              color="rgb(0,170,221)"
              class="ml-2"
              @click="searchByStatus()"
            >
              <v-icon>mdi-arrow-right</v-icon>
            </v-btn>
          </div>
        </div>
        <v-divider class="mx-10"></v-divider>

        <div class="d-flex flex-column">
          <div
            class="mt-8 ml-10"
            style="display: flex; align-items: center; width: 95%"
          >
            <p class="bold">{{ entries }} entries</p>
            <v-spacer></v-spacer>
            <p>Sort by</p>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <p class="text-capitalize ml-2 black--text" v-on="on">
                  {{ sortByText }}
                  <v-icon small left>mdi-chevron-down</v-icon>
                </p>
              </template>

              <v-list>
                <v-list-item
                  v-for="(item, index) in [
                    {
                      text: 'Date Registered (newest to oldest)',
                      value: { sort: 'dateVerified', dir: 'desc' },
                    },
                    {
                      text: 'Date Registered (oldest to newest)',
                      value: { sort: 'dateVerified', dir: 'asc' },
                    },
                    {
                      text: 'Alphabetically (ascending)',
                      value: { sort: 'doctorName', dir: 'asc' },
                    },
                    {
                      text: 'Alphabetically (descending)',
                      value: { sort: 'doctorName', dir: 'desc' },
                    },
                  ]"
                  :key="index"
                  @click="
                    sortByText = item.text;
                    sortBy = item.value.sort;
                    dir = item.value.dir;
                    searchByStatus();
                  "
                >
                  <v-list-item-title>
                    <p>{{ item.text }}</p>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

            <v-menu offset-y :close-on-content-click="false">
              <template v-slot:activator="{ on }">
                <p class="text-capitalize ml-2 black--text" v-on="on">
                  Display
                  <v-icon small left>mdi-chevron-down</v-icon>
                </p>
              </template>
              <v-list>
                <v-list-item-group v-model="displayArray" multiple>
                  <template v-for="(item, i) in displayItems">
                    <v-divider v-if="!item" :key="`divider-${i}`"></v-divider>

                    <v-list-item
                      v-else
                      :key="`item-${i}`"
                      :value="item"
                      active-class="rgb(0,169,221)"
                    >
                      <template v-slot:default="{ active, toggle }">
                        <v-list-item-content>
                          <v-list-item-title v-text="item"></v-list-item-title>
                        </v-list-item-content>

                        <v-list-item-action>
                          <v-checkbox
                            :input-value="active"
                            :true-value="item"
                            color="rgb(0,169,221)"
                            @click="toggle"
                          ></v-checkbox>
                        </v-list-item-action>
                      </template>
                    </v-list-item>
                  </template>
                </v-list-item-group>
              </v-list>
            </v-menu>
          </div>
          <table class="align-self-center mt-2" style="width: 95%">
            <tr class="table-head">
              <th>
                <p>Standby</p>
              </th>
              <th class="text-left" v-if="displayArray.includes('Name')">
                <p class="ml-2">Name</p>
              </th>
              <th
                style="white-space: nowrap"
                class="text-left pl-2"
                v-if="displayArray.includes('Status')"
              >
                <p>Status</p>
              </th>

              <th class="text-left" v-if="displayArray.includes('VAT')">
                <p>VAT</p>
              </th>

              <th
                class="text-left"
                v-if="displayArray.includes('Type of Doctor')"
              >
                <p>Type of Doctor</p>
              </th>

              <th
                class="text-left"
                v-if="displayArray.includes('Date Registered')"
              >
                <p>Date Registered</p>
              </th>

              <th class="text-left">
                <p>AM</p>
              </th>

              <th class="text-left">
                <p>Medical Association</p>
              </th>

              <th class="text-left">
                <p>Public Doctor</p>
              </th>
              <!-- <th class="text-left">
                <p>
                  Accepted
                  <br />Emergencies
                </p>
              </th>
              <th class="text-left">
                <p>
                  Completed
                  <br />Appointments
                </p>
              </th>
              <th class="text-left">
                <p>
                  Avg Availability
                  <br />(last 10 days)
                </p>
              </th>-->
              <th class="text-left" v-if="displayArray.includes('Actions')">
                <p>Actions</p>
              </th>
            </tr>

            <tr class="table-data" v-if="$store.state.loading">
              <td>
                <v-skeleton-loader
                  height="94"
                  type="list-item"
                ></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader
                  height="94"
                  type="list-item"
                ></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader
                  height="94"
                  type="list-item"
                ></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader
                  height="94"
                  type="list-item"
                ></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader
                  height="94"
                  type="list-item"
                ></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader
                  height="94"
                  type="list-item"
                ></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader
                  height="94"
                  type="list-item"
                ></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader
                  height="50"
                  type="avatar"
                ></v-skeleton-loader>
              </td>
            </tr>
            <tr class="table-data" v-if="$store.state.loading">
              <td>
                <v-skeleton-loader
                  height="94"
                  type="list-item"
                ></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader
                  height="94"
                  type="list-item"
                ></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader
                  height="94"
                  type="list-item"
                ></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader
                  height="94"
                  type="list-item"
                ></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader
                  height="94"
                  type="list-item"
                ></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader
                  height="94"
                  type="list-item"
                ></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader
                  height="94"
                  type="list-item"
                ></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader
                  height="50"
                  type="avatar"
                ></v-skeleton-loader>
              </td>
            </tr>
            <tr class="table-data" v-if="$store.state.loading">
              <td>
                <v-skeleton-loader
                  height="94"
                  type="list-item"
                ></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader
                  height="94"
                  type="list-item"
                ></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader
                  height="94"
                  type="list-item"
                ></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader
                  height="94"
                  type="list-item"
                ></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader
                  height="94"
                  type="list-item"
                ></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader
                  height="94"
                  type="list-item"
                ></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader
                  height="94"
                  type="list-item"
                ></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader
                  height="50"
                  type="avatar"
                ></v-skeleton-loader>
              </td>
            </tr>

            <tr class="table-data" v-if="$store.state.loading">
              <td>
                <v-skeleton-loader
                  height="94"
                  type="list-item"
                ></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader
                  height="94"
                  type="list-item"
                ></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader
                  height="94"
                  type="list-item"
                ></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader
                  height="94"
                  type="list-item"
                ></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader
                  height="94"
                  type="list-item"
                ></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader
                  height="94"
                  type="list-item"
                ></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader
                  height="94"
                  type="list-item"
                ></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader
                  height="50"
                  type="avatar"
                ></v-skeleton-loader>
              </td>
            </tr>

            <router-link
              v-else
              tag="tr"
              class="table-data"
              v-for="(doctor, index) in $store.state.doctors.doctors"
              :key="index"
              :to="'/doctors/' + doctor.doctorID"
            >
              <td>
                <div class="d-flex justify-center">
                  <v-checkbox
                    @change="standby(doctor)"
                    color="rgb(0,170,221)"
                    v-model="doctor.isVideoCallStandBy"
                  ></v-checkbox>
                </div>
              </td>

              <td v-if="displayArray.includes('Name')">
                <div class="ml-2" style="display: flex; align-items: center">
                  <!-- <img
                    style="z-index:10;border-radius:50%;height:40px !important; width:40px; !important"
                    :src="doctor.userProfile ? doctor.userProfile.profilePic : ''"
                    alt="photo"
                  />-->
                  <div class="ml-2 d-flex flex-column">
                    <p
                      style="white-space: normal"
                      class="font-weight-regular black--text"
                    >
                      <a
                        style="
                          text-decoration: none;
                          color: inherit;
                          cursor: pointer;
                        "
                        href
                        >{{
                          doctor.userProfile ? doctor.userProfile.firstName : ""
                        }}
                        {{
                          doctor.userProfile ? doctor.userProfile.lastName : ""
                        }}</a
                      >
                    </p>
                    <p class>
                      {{
                        doctor.userProfile ? doctor.userProfile.username : ""
                      }}
                    </p>
                  </div>
                </div>
              </td>

              <td
                style="white-space: nowrap"
                v-if="displayArray.includes('Status')"
                class="pl-2"
              >
                <div class="d-flex align-center">
                  <div
                    class="d-flex justify-center align-center"
                    v-if="doctor.BORevisedStatus === 'rejected'"
                  >
                    <div
                      style="height: 8px; width: 8px; border-radius: 50%"
                      class="blocked"
                    ></div>
                    <p class="ml-2">Rejected</p>
                  </div>
                  <div
                    class="d-flex justify-center align-center"
                    v-if="doctor.userProfile.isBlocked"
                  >
                    <div
                      style="height: 8px; width: 8px; border-radius: 50%"
                      class="blocked"
                    ></div>
                    <p class="ml-2">Blocked</p>
                  </div>
                  <div
                    class="d-flex justify-center align-center"
                    v-else-if="doctor.BORevisedStatus === 'accepted'"
                  >
                    <div
                      style="height: 8px; width: 8px; border-radius: 50%"
                      class="green"
                    ></div>
                    <p class="ml-2">Active</p>
                  </div>
                  <div
                    class="d-flex justify-center align-center"
                    v-else-if="doctor.BORevisedStatus === 'pending'"
                  >
                    <div
                      style="height: 8px; width: 8px; border-radius: 50%"
                      class="pending"
                    ></div>
                    <p class="ml-2">Pending Approval</p>
                  </div>
                </div>
              </td>

              <td v-if="displayArray.includes('VAT')">
                <p
                  class="text-capitalize link"
                  v-if="doctor.userProfile.taxId"
                  @click="
                    vatDialog = { open: true, vat: doctor.userProfile.taxId }
                  "
                >
                  {{ doctor.userProfile.taxId }}
                </p>
              </td>

              <td v-if="displayArray.includes('Type of Doctor')">
                <p class="text-capitalize">
                  {{
                    doctor.doctorAccredations
                      ? doctor.doctorAccredations.doctorTypeName
                      : ""
                  }}
                </p>
              </td>
              <td v-if="displayArray.includes('Date Registered')">
                <p>
                  {{
                    doctor.userProfile
                      ? convertDate(doctor.userProfile.createdAt)
                      : ""
                  }}
                </p>
              </td>

              <td class="text-left">
                <p>
                  {{
                    doctor.doctorAccredations
                      ? doctor.doctorAccredations.idNumber
                      : ""
                  }}
                </p>
              </td>

              <td class="text-left">
                <p>
                  {{
                    doctor.doctorAccredations
                      ? !!doctor.doctorAccredations.greekMedicalAssociationName
                        ? doctor.doctorAccredations.greekMedicalAssociationName
                        : doctor.doctorAccredations.docMedicalAssociation
                      : ""
                  }}
                </p>
              </td>

              <td class="text-left">
                <p>{{ doctor.isPublicSectorEmployee ? "YES" : "NO" }}</p>
              </td>
              <!-- <td>
                <p>{{doctor.userProfile ? doctor.userProfile.acceptedEmergencies : ''}}</p>
              </td>
              <td>
                <p>{{doctor.userProfile ? doctor.userProfile.completedAppointments : ''}}</p>
              </td>
              <td>
                <p>{{doctor.userProfile ? doctor.userProfile.avgAvailability : ''}}%</p>
              </td>-->
              <td v-if="displayArray.includes('Actions')">
                <div class="d-flex align-center" style="cursor: pointer">
                  <v-tooltip top v-if="doctor.BORevisedStatus == 'pending'">
                    <template v-slot:activator="{ on }">
                      <img
                        v-on="on"
                        class="mr-2"
                        style="height: 20px; width: 20px"
                        src="/img/ban.svg"
                        alt="ban"
                        @click.stop="
                          selectedDoctor = doctor;
                          rejectDialog = true;
                        "
                      />
                    </template>
                    <span>Reject</span>
                  </v-tooltip>

                  <v-tooltip top v-if="doctor.BORevisedStatus == 'pending'">
                    <template v-slot:activator="{ on }">
                      <img
                        v-on="on"
                        style="height: 20px; width: 20px"
                        src="/img/approve.svg"
                        alt="ban"
                        @click.stop="
                          selectedDoctor = doctor;
                          approveDialog = true;
                        "
                      />
                    </template>
                    <span>Accept</span>
                  </v-tooltip>

                  <v-tooltip top v-if="doctor.BORevisedStatus == 'rejected'">
                    <template v-slot:activator="{ on }">
                      <img
                        v-on="on"
                        style="height: 20px; width: 20px"
                        src="/img/approve.svg"
                        alt="ban"
                        @click.stop="
                          selectedDoctor = doctor;
                          approveDialog = true;
                        "
                      />
                    </template>
                    <span>Accept</span>
                  </v-tooltip>

                  <v-tooltip top v-if="doctor.userProfile.isBlocked">
                    <template v-slot:activator="{ on }">
                      <img
                        v-on="on"
                        style="height: 20px; width: 20px"
                        src="/img/approve.svg"
                        alt="ban"
                        @click.stop="
                          selectedDoctor = doctor;
                          unblockDialog = true;
                        "
                      />
                    </template>
                    <span>Unblock</span>
                  </v-tooltip>

                  <v-tooltip
                    top
                    v-if="
                      doctor.BORevisedStatus == 'accepted' &&
                      !doctor.userProfile.isBlocked
                    "
                  >
                    <template v-slot:activator="{ on }">
                      <img
                        v-on="on"
                        style="height: 20px; width: 20px"
                        src="/img/ban/ban.png"
                        alt="ban"
                        @click.stop="
                          selectedDoctor = doctor;
                          blockDialog = true;
                        "
                      />
                    </template>
                    <span>Block</span>
                  </v-tooltip>
                </div>
              </td>
            </router-link>
          </table>
          <div class="d-flex justify-end" style="width: 85%">
            <div class="d-flex">
              <p>Rows per page:</p>
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <p class="text-capitalize ml-2 black--text" v-on="on">
                    {{ rowsPerPage }}
                    <v-icon small left>mdi-chevron-down</v-icon>
                  </p>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(item, index) in [5, 10, 20, 30, 40, 50]"
                    :key="index"
                  >
                    <v-list-item-title
                      @click="
                        rowsPerPage = item;
                        currentPage = 1;
                        searchByStatus();
                      "
                      >{{ item }}</v-list-item-title
                    >
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>

            <div class="d-flex">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    :disabled="!!(currentPage == 1 || currentPage == 0)"
                    @click="
                      currentPage--;
                      searchByStatus();
                    "
                    >mdi-chevron-left</v-icon
                  >
                </template>
                <span>Previous</span>
              </v-tooltip>

              <p>
                Page
                <span class="black--text">{{ currentPage }}</span>
                of {{ totalPageCount }}
              </p>

              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    :disabled="
                      !!(currentPage == totalPageCount || totalPageCount == 0)
                    "
                    @click="
                      currentPage++;
                      searchByStatus();
                    "
                    >mdi-chevron-right</v-icon
                  >
                </template>
                <span>Next</span>
              </v-tooltip>
            </div>
          </div>
        </div>
      </div>
    </div>

    <v-dialog v-model="rejectDialog" width="500">
      <v-card class="pt-12">
        <v-card-text>
          <div class="d-flex flex-column align-center justify-center">
            <h1>
              Reject Dr.
              {{ selectedDoctor ? selectedDoctor.userProfile.firstName : "" }}
              {{ selectedDoctor ? selectedDoctor.userProfile.lastName : "" }}?
            </h1>
            <p class="text-center mt-4">
              Prevent this user from being able to receive any emergency or
              appointment requests from patients and access your network.
            </p>
            <p class="text-center mt-3">
              However they will be still allowed to login and make changes to
              their profile and personal info.
            </p>
          </div>
          <div class="d-flex justify-center mt-4">
            <v-btn
              class="text-capitalize mr-2"
              outlined
              color="rgb(164,164,164)"
              rounded
              @click="rejectDialog = false"
              >Cancel</v-btn
            >
            <v-btn
              class="text-capitalize white--text"
              color="rgb(255,0,0)"
              depressed
              rounded
              @click="reject(selectedDoctor)"
              >Reject</v-btn
            >
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="approveDialog" width="500">
      <v-card class="pt-12">
        <v-card-text>
          <div class="d-flex flex-column align-center justify-center">
            <h1>
              Approve Dr.
              {{ selectedDoctor ? selectedDoctor.userProfile.firstName : "" }}
              {{ selectedDoctor ? selectedDoctor.userProfile.lastName : "" }}?
            </h1>
            <p class="text-center mt-4">
              This user will be considered as a trusted doctor and will be able
              to receive emergency requests, book appointments with patients and
              access your network.
            </p>
          </div>
          <div class="d-flex justify-center mt-4">
            <v-btn
              class="text-capitalize mr-2"
              outlined
              color="rgb(164,164,164)"
              rounded
              @click="approveDialog = false"
              >Cancel</v-btn
            >
            <v-btn
              class="text-capitalize white--text"
              color="rgb(113,210,48)"
              depressed
              rounded
              @click="approve(selectedDoctor)"
              >Approve</v-btn
            >
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="blockDialog" width="500">
      <v-card class="pt-12">
        <v-card-text>
          <div class="d-flex flex-column align-center justify-center">
            <h1>
              Block Dr.
              {{ selectedDoctor ? selectedDoctor.userProfile.firstName : "" }}
              {{ selectedDoctor ? selectedDoctor.userProfile.lastName : "" }}?
            </h1>
            <p class="text-center mt-4">
              Prevent this user from being able to receive emergency or
              appointments requests. However they will be still allowed to login
              to make changes to their profile and personal info or access
              previous cases.
            </p>
          </div>
          <div class="d-flex justify-center mt-4">
            <v-btn
              class="text-capitalize mr-2"
              outlined
              color="rgb(164,164,164)"
              rounded
              @click="blockDialog = false"
              >cancel</v-btn
            >
            <v-btn
              class="text-capitalize white--text"
              rounded
              color="rgb(255,0,0)"
              @click="block(selectedDoctor)"
              >Block</v-btn
            >
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="unblockDialog" width="500">
      <v-card class="pt-12">
        <v-card-text>
          <div class="d-flex flex-column align-center justify-center">
            <h1>
              Block Dr.
              {{ selectedDoctor ? selectedDoctor.userProfile.firstName : "" }}
              {{ selectedDoctor ? selectedDoctor.userProfile.lastName : "" }}?
            </h1>
            <p class="text-center mt-4">
              This user will be re-activated and able to use your services again
              (receive emergency requests, appointments etc).
            </p>
          </div>
          <div class="d-flex justify-center mt-4">
            <v-btn
              class="text-capitalize mr-2"
              outlined
              color="rgb(164,164,164)"
              rounded
              @click="unblockDialog = false"
              >cancel</v-btn
            >
            <v-btn
              class="text-capitalize white--text"
              rounded
              color="rgb(113,210,48)"
              @click="unblock(selectedDoctor)"
              >Unblock</v-btn
            >
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="vatDialog.open" max-width="500px">
      <div class="white d-flex flex-column pa-5" v-if="vatDialog.open">
        <v-progress-circular
          size="80"
          width="4"
          indeterminate
          color="#00aadd"
          v-if="vatLoader"
          class="align-self-center"
        ></v-progress-circular>

        <template v-else>
          <div v-if="vatError" class="d-flex flex-column align-center">
            <div class="text-center mb-4">
              Doctor's info was not found on TAXISnet.
            </div>

            <v-btn
              small
              depressed
              @click="vatDialog = { open: false, vat: null }"
              >Close</v-btn
            >
          </div>

          <div v-else class="text-center">
            <div class="body-1 font-weight medium mb-2">
              {{ vatData.registerdName }}
            </div>

            <div class="body-1 font-weight medium mb-2">
              VAT: {{ vatData.afm }}
            </div>

            <div class="body-1 mb-2">ΚΑΔ:</div>

            <ul class="mb-5">
              <li v-for="kad in vatData.KADs" :key="kad.code">
                {{ kad.description }} ({{ kad.kindDescription }})
              </li>
            </ul>

            <v-btn
              small
              depressed
              @click="vatDialog = { open: false, vat: null }"
              >Close</v-btn
            >
          </div>
        </template>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";

export default {
  created() {
    console.log("created");
    this.$store.dispatch("setActiveIndex", 2).then(() => {
      this.$store
        .dispatch("getAllDoctors", {
          pageSize: this.rowsPerPage,
          pageNo: 1,
          activeStatus: "all",
          sortBy: this.sortBy,
          dir: this.dir,
          search: this.search,
        })
        .then((res) => {
          this.entries = res.data.totalCount;
          this.currentPage = res.data.currentPage;
          this.totalPageCount = res.data.totalPageCount;
        })
        .catch((err) => {
          this.totalPageCount = 0;
        });
    });
  },
  data() {
    return {
      vatDialog: {
        open: false,
        vat: null,
      },
      vatLoader: false,
      vatData: null,
      vatError: false,
      prefecture: "All",
      prefectureId: null,
      municipality: "All",
      municipalityId: null,
      sortByText: "Date Registered (newest to oldest)",
      countryCode: null,
      displayArray: [
        "Name",
        "Status",
        "VAT",
        "Country",
        "Type of Doctor",
        "Date Registered",
        "Actions",
      ],
      displayItems: [
        "Name",
        "Status",
        "VAT",
        "Country",
        "Type of Doctor",
        "Date Registered",
        "Actions",
      ],
      dir: "desc",
      search: "",
      sortBy: "dateVerified",
      rowsPerPage: 50,
      totalPageCount: null,
      currentPage: 0,
      selectedDoctor: null,
      approveDialog: false,
      rejectDialog: false,
      blockDialog: false,
      unblockDialog: false,
      entries: 0,
      statusSearch: "All",
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
    };
  },
  methods: {
    searchByStatus(status) {
      this.$store
        .dispatch("getAllDoctors", {
          pageSize: this.rowsPerPage,
          pageNo: this.currentPage,
          activeStatus: this.statusSearch.toLowerCase(),
          sortBy: this.sortBy,
          dir: this.dir,
          prefecture: this.prefectureId,
          municipality: this.municipalityId,
          search: this.search,
        })
        .then((res) => {
          this.entries = res.data.totalCount;
          this.totalPageCount = res.data.totalPageCount;
          if (this.currentPage > this.totalPageCount) {
            console.log(this.currentPage, "current");
            console.log(this.totalPageCount, "total");
            console.log(this.currentPage, "current again");
          } else {
            this.currentPage = res.data.currentPage;
          }
        })
        .catch((err) => {
          console.log("xaxahxaxahx");
          this.currentPage = 0;
          this.totalPageCount = 0;
        });
    },

    selectDoctor(id) {
      this.$router.push(`/doctors/${id}`);
    },

    approve(doctor) {
      const credentials = {
        doctorId: doctor.doctorID,
        BORevisedStatus: "accepted",
      };
      this.$store.dispatch("approveDoctor", credentials).then(() => {
        this.approveDialog = false;
      });
    },
    reject(doctor) {
      const credentials = {
        doctorId: doctor.doctorID,
        BORevisedStatus: "rejected",
      };
      this.$store.dispatch("rejectDoctor", credentials).then(() => {
        this.rejectDialog = false;
      });
    },
    block(doctor) {
      const credentials = {
        userId: doctor.userProfile.userId,
        isBlocked: true,
      };
      this.$store.dispatch("blockDoctor", credentials).then(() => {
        this.blockDialog = false;
      });
    },
    unblock(doctor) {
      const credentials = {
        userId: doctor.userProfile.userId,
        isBlocked: false,
      };
      this.$store.dispatch("unblockDoctor", credentials).then(() => {
        this.unblockDialog = false;
      });
    },
    standby(doctor) {
      this.$store.dispatch("setStandBy", doctor);
      //alert('hi')
    },
    convertDate(date2) {
      const date = new Date(date2);
      const day = date.getDate();
      const month = date.getMonth();
      const year = date.getFullYear();
      return day + " " + this.months[month].substr(0, 3) + " " + year;
    },
  },
  watch: {
    async "vatDialog.open"(newValue, oldValue) {
      if (newValue) {
        try {
          this.vatLoader = true;

          const res = await axios.post(
            "https://dn2me-production-traveller.azurewebsites.net/api/system/boDoctorVatCheck",
            {
              taxId: this.vatDialog.vat,
            }
          );

          this.vatData = res.data;

          console.log(this.vatData);
        } catch (e) {
          this.vatError = true;
          console.log(e);
        }

        this.vatLoader = false;
      } else {
        this.vatLoader = false;
        this.vatError = false;
        this.vatData = null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
p {
  color: rgb(107, 107, 107);
}
img {
  height: 35px;
  width: 35px;
}

.link {
  cursor: pointer;
  color: #00aadd;
  transition: all 0.2s;

  &:hover {
    text-decoration: underline;
  }
}
</style>